enum DeleteInviteConstants {
  OPEN_DELETE_INVITATION_MODAL = '@DeleteInviteContainer/OPEN_DELETE_INVITATION_MODAL',
  CLOSE_DELETE_INVITATION_MODAL = '@DeleteInviteContainer/CLOSE_DELETE_INVITATION_MODAL',
  DELETE_INVITATION = '@DeleteInviteContainer/DELETE_INVITATION',
  DELETE_INVITATION_REQUEST = '@DeleteInviteContainer/DELETE_INVITATION_REQUEST',
  DELETE_INVITATION_REQUEST_SUCCESS = '@DeleteInviteContainer/DELETE_INVITATION_REQUEST_SUCCESS',
  DELETE_INVITATION_REQUEST_ERROR = '@DeleteInviteContainer/DELETE_INVITATION_REQUEST_ERROR',
}

export default DeleteInviteConstants;
